<template>
  <div v-if="shopDistributions && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="shopDistributions"
    />
  </div>
</template>
<script>
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import Waves from "@/api/waves";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    shopDistributions: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("shopDistribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;
          //获取配送单详情
          Waves.shopDistributionsPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.shopDistributions = response.data.shop_distributions.map(
                  (d) => {
                    return Object.assign({} , d , {
                      custom_footer: response.data.distribution_print_stock_title_and_footer
                        ? response.data.distribution_print_stock_title_and_footer.custom_footer
                        : ""
                    })
                  }
                );
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>